import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const responsibilityConfirmation: AnswerPathTreeNode = {
  path: 'responsibilityConfirmation',
  nodeId: NodeIds.responsibilityConfirmation,
};
